'use client';

import { useEffect } from 'react';

export default function PerformanceMonitor() {
  useEffect(() => {
    // Monitor page load performance
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        setTimeout(() => {
          const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
          const paint = performance.getEntriesByType('paint');
          
          if (navigation) {
            console.log('Page Load Performance:', {
              DNS: navigation.domainLookupEnd - navigation.domainLookupStart,
              TCP: navigation.connectEnd - navigation.connectStart,
              TTFB: navigation.responseStart - navigation.requestStart,
              DOMContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
              Load: navigation.loadEventEnd - navigation.loadEventStart,
              Total: navigation.loadEventEnd - navigation.fetchStart
            });
          }

          if (paint.length > 0) {
            console.log('Paint Performance:', {
              FCP: paint.find(p => p.name === 'first-contentful-paint')?.startTime,
              LCP: paint.find(p => p.name === 'largest-contentful-paint')?.startTime
            });
          }
        }, 0);
      });
    }
  }, []);

  return null; // This component doesn't render anything
}
